/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-tab-group[_ngcontent-%COMP%]{max-height:85vh}  .mat-tab-label{width:50%}  form{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}  mat-dialog-content{-webkit-box-flex:1;-ms-flex:1;flex:1}  .mat-tab-body-content{overflow-x:hidden;height:100%}"];
export { styles as styles };



// WEBPACK FOOTER //
// /app/src/app/settings/pages/settings/settings.component.scss.shim.ngstyle.js.pre-build-optimizer.js